import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {BaseHttpService} from '@shared/infrastructure/services/http/base-http.service';
import {environment} from '@env/environment';
import {CheckoutPayload} from '@features/payment/infrastructure/dto/payment-payload.dto';
import {RefundCompletedDTO, RefundRequestDTO} from '@features/payment/domain/model/refund.model';

interface WalletCheckoutResponse {
  transactionId: string;
}

@Injectable({providedIn: 'root'})
export class WalletsGateway extends BaseHttpService {
  protected readonly baseUrl = environment.apiURL;

  checkout(payload: CheckoutPayload): Observable<string> {
    return this.post<WalletCheckoutResponse>('/api/v2/wallets', payload).pipe(
      map(({transactionId}) => transactionId)
    );
  }

  refund(refundRequest: RefundRequestDTO): Observable<RefundCompletedDTO> {
    return this.post<RefundCompletedDTO>('/api/v2/wallets/refund', refundRequest);
  }
}

